module.exports = __webpack_public_path__ + "img/money-wallet.f01bb1b4.svg";